import styled from "styled-components";

export const GeralWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const BubbleContainer = styled.div`
  background-color: ${(props) => props.theme.topElementsColor};
  padding: 20px;
  margin-top: 10px;
  margin-left: 10px;
  border-radius: 15px;
  height: fit-content;
`;

export const WrapperAff = styled.div`

    

`
export const Paff = styled.p`
margin-bottom: 10px;
`